import images from "./images";
import { useState, useEffect } from "react";

function Exhibition() {
  const [num, setNum] = useState(1);

  function start() {
    document
      .querySelectorAll(".product-display-thumbnail-exhibition")
      .forEach((item) => {
        item.classList.remove("product-display-thumbnail-exhibition-acive");
        if (+item.id === num) {
          item.classList.add("product-display-thumbnail-exhibition-acive");
        }
      });
  }
  useEffect(start);

  function handleNum(e) {
    setNum(+e.target.id);
    document
      .querySelectorAll(".product-display-thumbnail-exhibition")
      .forEach((item) => {
        item.classList.remove("product-display-thumbnail-exhibition-acive");
      });
    e.target.classList.add("product-display-thumbnail-exhibition-acive");
  }

  function increaseSlideshow() {
    start();
    setNum((prev) => {
      return prev < 4 ? prev + 1 : prev;
    });
  }
  function decreaseSlideshow() {
    start();
    setNum((prev) => {
      return prev > 1 ? prev - 1 : prev;
    });
  }

  function closeExhibition() {
    document.querySelector(".overlay").classList.remove("overlay-open");
    document.querySelector(".product-exhibition").classList.add("hidden");
  }

  window.addEventListener("resize", closeExhibition);

  return (
    <div className="product-exhibition absolute hidden">
      <div className="closebtn-div">
        <svg
          width="14"
          height="15"
          xmlns="http://www.w3.org/2000/svg"
          className="close-btn2"
          onClick={closeExhibition}
        >
          <path
            d="m11.596.782 2.122 2.122L9.12 7.499l4.597 4.597-2.122 2.122L7 9.62l-4.595 4.597-2.122-2.122L4.878 7.5.282 2.904 2.404.782l4.595 4.596L11.596.782Z"
            fill="#69707D"
            fillRule="evenodd"
            className="close-btn2-color"
          />
        </svg>
      </div>
      <img
        alt=""
        src={images[num - 1].img}
        className="product-display-large-exhibition"
      />
      <div className="product-display-control">
        <img
          id={images[0].id}
          alt=""
          src={images[0].thumbnail}
          className="product-display-thumbnail-exhibition"
          onClick={handleNum}
        />
        <img
          id={images[1].id}
          alt=""
          src={images[1].thumbnail}
          className="product-display-thumbnail-exhibition"
          onClick={handleNum}
        />
        <img
          id={images[2].id}
          alt=""
          src={images[2].thumbnail}
          className="product-display-thumbnail-exhibition"
          onClick={handleNum}
        />
        <img
          id={images[3].id}
          alt=""
          src={images[3].thumbnail}
          className="product-display-thumbnail-exhibition"
          onClick={handleNum}
        />
      </div>
      <div className="slide-control-exhibition">
        <div className="prev" onClick={decreaseSlideshow}>
          <svg width="12" height="18" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M11 1 3 9l8 8"
              stroke="#1D2026"
              strokeWidth="3"
              fill="none"
              fillRule="evenodd"
            />
          </svg>
        </div>
        <div className="next" onClick={increaseSlideshow}>
          <svg width="12" height="18" xmlns="http://www.w3.org/2000/svg">
            <path
              d="m2 1 8 8-8 8"
              stroke="#1D2026"
              strokeWidth="3"
              fill="none"
              fillRule="evenodd"
            />
          </svg>
        </div>
      </div>
    </div>
  );
}

export default Exhibition;
